// extracted by mini-css-extract-plugin
export default {"reportFailure":"K6Tup","backArrow":"ukicg","emptyField":"QmY4E","formSection":"NqBeJ","requiredLabel":"HsPrH","formActions":"uyH9b","formBtn":"lKgwT","container":"VkVq1"};